import PropTypes from 'prop-types';
import { useState, useEffect, useContext, createContext } from 'react';
import { useRouter } from 'next/router';
import merge from 'deepmerge';
import usePrevious from 'hooks/usePrevious';

const useProvideAnalytics = () => {
  const [location, setLocation] = useState();
  const router = useRouter();

  const referrer = usePrevious(location);

  const identify = (userId = null, traits = {}, options = {}) =>
    window.yesware?.identify(
      userId,
      traits,
      merge(options, {
        context: {
          page: {
            referrer,
          },
        },
      }),
    );

  const track = (event, properties = {}, options = {}) =>
    window.yesware?.track(
      event,
      properties,
      merge(options, {
        context: {
          page: {
            referrer,
          },
        },
      }),
    );

  const page = () => {
    window.yesware?.page(
      {
        referrer,
      },
      {
        context: {
          page: {
            referrer,
          },
        },
      },
    );
  };

  useEffect(() => {
    setLocation(window.location.href);

    if (location) {
      page();
    }
  }, [router.asPath]);

  return {
    identify,
    track,
  };
};

// create the context
const analyticsContext = createContext();

// provide it to the tree
export const ProvideAnalytics = ({ children }) => {
  const analytics = useProvideAnalytics();
  return (
    <analyticsContext.Provider value={analytics}>
      {children}
    </analyticsContext.Provider>
  );
};

export const useAnalytics = () => useContext(analyticsContext);

ProvideAnalytics.propTypes = {
  children: PropTypes.node.isRequired,
};
